import API_BASE_URL from "../config";

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const handle = async (res) => {
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `Request failed with status ${res.status}`);
  }
  const text = await res.text();
  return text ? JSON.parse(text) : null;
};

export const listTemplates = (includeInactive = false) =>
  fetch(`${API_BASE_URL}/api/checklist-templates?includeInactive=${includeInactive}`, {
    headers: authHeaders(),
  }).then(handle);

export const getTemplatesForTaskType = (taskType) =>
  fetch(`${API_BASE_URL}/api/checklist-templates/for-task-type?taskType=${encodeURIComponent(taskType || "")}`, {
    headers: authHeaders(),
  }).then(handle);

export const createTemplate = (payload) =>
  fetch(`${API_BASE_URL}/api/checklist-templates`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  }).then(handle);

export const updateTemplate = (templateId, payload) =>
  fetch(`${API_BASE_URL}/api/checklist-templates/${templateId}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  }).then(handle);

export const deleteTemplate = (templateId) =>
  fetch(`${API_BASE_URL}/api/checklist-templates/${templateId}`, {
    method: "DELETE",
    headers: authHeaders(),
  }).then(handle);

export const addTemplateItem = (templateId, text) =>
  fetch(`${API_BASE_URL}/api/checklist-templates/${templateId}/items`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ text }),
  }).then(handle);

export const updateTemplateItem = (itemId, text) =>
  fetch(`${API_BASE_URL}/api/checklist-templates/items/${itemId}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify({ text }),
  }).then(handle);

export const deleteTemplateItem = (itemId) =>
  fetch(`${API_BASE_URL}/api/checklist-templates/items/${itemId}`, {
    method: "DELETE",
    headers: authHeaders(),
  }).then(handle);

export const reorderTemplateItems = (templateId, orderedItemIds) =>
  fetch(`${API_BASE_URL}/api/checklist-templates/${templateId}/items/reorder`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(orderedItemIds),
  }).then(handle);
